import { Box, Text } from '@wix/design-system';
import React from 'react';
import s from '../whoisResultsPage.scss';
export const InfoRow = _ref => {
  let {
    label,
    value
  } = _ref;
  if (!value) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    secondary: true,
    className: s.infoRowLabel
  }, label), /*#__PURE__*/React.createElement("span", {
    className: s.infoRowValue
  }, typeof value === 'string' ? /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, value) : value));
};
//# sourceMappingURL=InfoRow.js.map